<template>
  <div id="window">
    <div v-if="$route.name != 'Login' && $route.name != 'Admin' && $route.name != 'forgot' && $route.name != 'registration'" id="nav">
      <Navbar />
    </div>
    <router-view id="view"></router-view>
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue";
export default {
  components: {
    Navbar,
  },
  beforeMount() {
    if (!localStorage.getItem("isLogged")) {
      this.$router.replace("/login");
    }
  },
  methods: {

  },
  created() {
    document.querySelector(":not(.dots_menu)").addEventListener("click", () => {
      document.querySelectorAll(".dots_menu").forEach(el => {
        el.style.display = "none"
      });
    })
    //window;
  }
};
</script>

<style lang="stylus">
#window {
  display: flex;
  width: 100%;
}
h3 {
  margin-top: 0;
  font-size: 24px;
  font-weight: 600;
}
.info {
  display: flex;
  align-items: center;
  position: fixed;
  right: 50px;
  top: 70px;
  margin-bottom: 0;
  z-index: 997;

  & h3 {
    margin: 0;
    margin-left: 50px;
    font-size: 20px;
    font-weight: 400;
  }

  & .btn-floating {
    margin-left: 20px;
  }
}
.top-control {
  position: fixed;
  right: 50px;
  bottom: auto;
  top: 70px;
  margin-bottom: 0;
  z-index: 997;
}

.select-wrapper input.select-dropdown:focus {
  border-bottom: 1px solid black;
}

.dropdown-content li > a, .dropdown-content li > span {
  color: black;
}

.checkbox[type='checkbox']:checked + span:before {
  border-right: 2px solid #333;
  border-bottom: 2px solid #333;
}

.checkbox[type='checkbox']:indeterminate+span:not(.lever):before {
  border-right: 2px solid #333;
}

// Правка табов для материалайз
.tabs .tab a {
  color: rgba(38, 166, 154, 0.7);
  filter: saturate(0);
  /* Custom Text Color */
}

.tabs .tab a:hover {
  color: #26a69a;
  filter: saturate(0);
  /* Custom Color On Hover */
}

.tabs .tab a:focus.active, .tabs .tab a.active {
  color: #26a69a;
  filter: saturate(0);
  /* Custom Text Color While Active */
  background-color: rgba(38, 166, 154, 0.2);
  filter: saturate(0);
  /* Custom Background Color While Active */
}

.tabs .indicator {
  background-color: rgba(38, 166, 154, 0.2);
  filter: saturate(0);
}
input:not([type]).dp__input {
  padding-left: 35px;
  font-size: 15px;
  width: 170px;
}
.dp__main .dp__input_wrap {
  width: 230px;
}
.dp__main {
  width: 185px;
}
.modal_content .dp__main .dp__input_wrap {
  width: 145px;
}
.modal_content input:not([type]).dp__input {
  width: 95px;
}
.dp__clear_icon {
  top: 43%;
}
</style>
